"use client"

import { Image } from '@akinon/next/components';
import { useLocalization } from '@akinon/next/hooks';
import { formatLocalizedDate } from '@theme/utils/parse-localized-date';

function BlogDetailContent({attributes}) {
  const {locale, t} = useLocalization();
  const safeLocale = locale === 'tr' ? 'tr' : 'en';
  const formattedDate = formatLocalizedDate(attributes?.date?.value, safeLocale);
  const toc = Array.isArray(attributes?.toc) ? attributes.toc : [];

  return (
    <>
      <div className='px-5 pt-12 max-w-[700px] mx-auto'>
        <h1 className="text-[32px] lg:text-[48px] leading-[110%] lg:text-center lg:px-3 font-medium text-primary-black mb-6 lg:mb-[30px]">
          {attributes?.title?.value}
        </h1>

        <div className='flex justify-between text-sm mb-6 text-gray pt-6 lg:pt-8 lg:mb-10 border-t border-[#CDCFCE]'>
          <div className='whitespace-nowrap'>
            {formattedDate}
          </div>
          <div className='flex gap-x-1 whitespace-nowrap'>
            {attributes?.reading_time?.value} {t('common.blog.minutes')}
            <span className=''>
              {t('common.blog.reading')}
            </span>
          </div>
        </div>

        <div>
          <Image
            src={attributes?.image?.kwargs?.url}
            alt={attributes?.title?.value || 'Yatsan Blog'}
            fill
            imageClassName="object-cover"
            aspectRatio={660 / 300}
            sizes="(min-width: 660px) 660px, 100vw"
            className="w-full h-auto mb-6 lg:mb-[50px]" />

          {toc?.length > 0 && (
            <nav
              aria-label={t('common.blog.table_of_contents')}
              className='mb-8 lg:mb-10 rounded-lg border border-[#CDCFCE] p-5'
            >
              <p className='text-lg font-medium text-primary-black mb-3'>
                {t('common.blog.table_of_contents')}
              </p>
              <ul className='space-y-2'>
                {toc?.map((item) => (
                  <li
                    key={item?.id}
                    className={item?.level >= 3 ? 'pl-4' : ''}
                  >
                    <a
                      href={`#${item?.id}`}
                      className='text-sm text-gray hover:text-primary-black hover:underline'
                    >
                      {item?.text}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          )}

          <div className='prose-custom lg:prose-customLg [&_h2]:scroll-mt-28 [&_h3]:scroll-mt-28'
            dangerouslySetInnerHTML={{ __html: attributes?.description?.value || '' }} />

        </div>
      </div>
    </>
  )
}

export default BlogDetailContent;
